import classNames from 'classnames';
import React from 'react';

import styles from '../../statics/styles/image-viewer.rtlignore.scss';
import InPluginInput from '../InPluginInput';
import type { ImageClickActionConfig } from '../viewer/get-image-click-action-config';

export type EditorImageCaptionProps = {
  onCaptionChange: (caption: string) => void;
  imageType: ImageClickActionConfig['type'];
  caption: string;
};

export const EditorImageCaption = ({
  onCaptionChange,
  imageType,
  caption,
}: EditorImageCaptionProps) => {
  if (!caption) return null;

  const isLinkImage = imageType === 'link' || imageType === 'anchor';
  const classes = classNames(styles.imageCaption, { [styles.link]: isLinkImage });

  return <InPluginInput className={classes} value={caption} onChange={onCaptionChange} />;
};
